/**
 * Preferences des effets visuels.
 * Persiste dans localStorage. Chaque effet peut etre active/desactive.
 */

const STORAGE_KEY = 'cof2-effects-prefs';

export interface EffectsPrefs {
  particles: boolean;
  shader: boolean;
  metaballs: boolean;
  tilt: boolean;
  cursorGlow: boolean;
  runes: boolean;
  portal: boolean;
  pageTransitions: boolean;
  gyroscope: boolean;
  magnetic: boolean;
  morphText: boolean;
  typing: boolean;
  counters: boolean;
}

const DEFAULTS: EffectsPrefs = {
  particles: true,
  shader: true,
  metaballs: true,
  tilt: true,
  cursorGlow: true,
  runes: true,
  portal: true,
  pageTransitions: true,
  gyroscope: true,
  magnetic: true,
  morphText: true,
  typing: true,
  counters: true,
};

export function loadEffectsPrefs(): EffectsPrefs {
  try {
    const stored = localStorage.getItem(STORAGE_KEY);
    if (stored) return { ...DEFAULTS, ...JSON.parse(stored) };
  } catch {}
  return { ...DEFAULTS };
}

export function saveEffectsPrefs(prefs: EffectsPrefs): void {
  localStorage.setItem(STORAGE_KEY, JSON.stringify(prefs));
}

export function isEffectEnabled(key: keyof EffectsPrefs): boolean {
  return loadEffectsPrefs()[key];
}
